import React from 'react';
import PropTypes from 'prop-types';
import { Row, Col, Badge } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBell } from '@fortawesome/free-solid-svg-icons';
import { v4 as generateUnid } from 'uuid';
import Translate from '../common/Translate';
import ReportImage from './ReportImage';
import { currencySign } from '../../Utils/currencySign';

const DamagesList = (props) => {
  const { damages, referential, formId, section, symbol, country } = props;
  const listDamages = [];
  let block;

  if (!damages) return <Translate code="no_damages" />;
  damages.forEach((damage, index) => {
    if (damage.cost > 0) listDamages[index] = damage;
  });

  if (listDamages.length > 0) {
    block = listDamages.map((damage) => (
      <Damage
        country={country}
        key={generateUnid()}
        damage={damage}
        displayReferential={referential}
        formId={formId}
        section={section}
        symbol={symbol}
      />
    ));
  } else {
    return <Translate code="no_damages" />;
  }

  //   let blockWithTitle = <React.Fragment>
  //      {isMobile && <hr />}
  //     <Row><p className="damages-title float-left">{t('damages_title')}</p></Row>
  //     {block}
  //   </React.Fragment>

  //   return section === 'servicing' ? blockWithTitle : block
  return block;
};

DamagesList.propTypes = {
  referential: PropTypes.string.isRequired,
  formId: PropTypes.string.isRequired,
  damages: PropTypes.shape().isRequired,
  section: PropTypes.string.isRequired,
  symbol: PropTypes.string.isRequired,
  country: PropTypes.string.isRequired,
};

export default DamagesList;

function Damage(props) {
  const { displayReferential, formId, damage, symbol, country } = props;
  const { element, cost, custom_damage, reconditionning, damage_picture, damage_picture2, referential, is_custom } =
    damage;

  if (parseInt(cost, 10) === 0 && is_custom === '') return null;

  if (referential !== displayReferential) return null;

  return (
    <>
      <Row className="margin-bottom-dmgs">
        <Col xs="12" lg="3">
          <p className="report-element-value">
            <span className="margin-bottom-dmgs" data-cy={element}>
              <Translate code={element} />
            </span>
          </p>
        </Col>
      </Row>
      <Row>
        <Col xs="12" lg="6">
          <div>
            <p className="report-element-label float-left">
              {is_custom && (
                <span data-cy={`${element}_label`}>
                  {custom_damage}{' '}
                  <Badge color="danger">
                    <FontAwesomeIcon icon={faBell} className="mr-1" />
                    <Translate code="is_custom" />
                  </Badge>
                </span>
              )}
              {!is_custom && <Translate code={reconditionning} />}
            </p>
            {cost > 0 && (
              <p className="report-element-value float-right text-danger mr-0" data-cy={`${element}_cost`}>
                {currencySign(cost, country)} <Translate code={symbol} />
              </p>
            )}
          </div>
        </Col>

        {damage_picture && (
          <Col xs="12" className="mr-top-30">
            <div className="scroll-wrapper">
              <div className="thumbnails">
                <ul>
                  {damage_picture !== '' && damage_picture !== null && damage_picture !== undefined && (
                    <li>
                      <div className="vehicule-pictures-container">
                        <ReportImage imageId={damage_picture} formId={formId} allImages={[]} />
                      </div>
                    </li>
                  )}
                  {damage_picture2 !== '' && damage_picture2 !== null && damage_picture2 !== undefined && (
                    <li>
                      <div className="vehicule-pictures-container">
                        <ReportImage imageId={damage_picture2} formId={formId} allImages={[]} />
                      </div>
                    </li>
                  )}
                </ul>
              </div>
            </div>
          </Col>
        )}
      </Row>
    </>
  );
}

Damage.propTypes = {
  displayReferential: PropTypes.string.isRequired,
  formId: PropTypes.string.isRequired,
  damage: PropTypes.shape().isRequired,
  symbol: PropTypes.string.isRequired,
  country: PropTypes.string.isRequired,
};
